import React from 'react';
import { motion } from 'framer-motion';
import { Reveal } from './ui/Reveal';
import { Megaphone, FileText, Send, Users, Filter, Mail, Copy, Clock } from 'lucide-react';
import { TTIco, IGIco } from './page/Mockups';
export const CastingCalls = () => {
  return <section className="py-24 bg-white overflow-hidden" data-id="element-277" data-mp="ldvvkigxqm6b">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-278" data-mp="lee1y7xbagry">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-14 lg:gap-16 items-center" data-id="element-279" data-mp="3tsw45t0kn23n">
          {/* Copy */}
          <Reveal data-id="element-280" data-mp="3ovmgoiwqt0ig">
            <div data-id="element-281" data-mp="3ow5qtdg5iklx">
              <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-zano-blush text-zano-pink text-xs font-semibold border border-zano-pink/20 mb-5" data-id="element-282" data-mp="3owp9wxhjff1j">
                <Megaphone size={13} data-id="element-283" data-mp="2ml5u4my4fg0" /> Casting Calls
              </span>
              <h2 className="text-3xl md:text-4xl font-bold text-zano-charcoal mb-4 leading-tight" data-id="element-284" data-mp="1i3ddbvt6zyod">
                Post one brief. Reach 400+ talent agencies instantly.
              </h2>
              <p className="text-lg text-gray-600 mb-6" data-id="element-285" data-mp="orhddgd7fqs3">
                Post a campaign brief with your influencer requirements, budget,
                and deliverables. Instantly notify 400+ talent agencies on Zano:
                "Do you have the right creators for this?"
              </p>

              <ul className="space-y-4" data-id="element-286" data-mp="12r8ys261w9g4">
                <li className="flex items-start gap-3" data-id="element-287" data-mp="12q7cf1jl40j3">
                  <div className="mt-0.5 bg-zano-lavender rounded-full p-1 shrink-0" data-id="element-288" data-mp="60zzghx16zqs">
                    <Send size={15} className="text-zano-charcoal" data-id="element-289" data-mp="a1sa9fljxcp6" />
                  </div>
                  <span className="text-gray-700 text-sm" data-id="element-290" data-mp="f14vjvwrybpn">
                    <span className="font-semibold text-zano-charcoal" data-id="element-291" data-mp="ezlgg8muu6pg">
                      Agencies pitch instantly
                    </span>{' '}
                    — Talent managers review your brief and submit matching
                    creators from their live roster with one click, adding
                    custom quotes and notes.
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-292" data-mp="ul6ij7xcc0iw">
                  <div className="mt-0.5 bg-zano-lavender rounded-full p-1 shrink-0" data-id="element-293" data-mp="pnmtre30o5cp">
                    <Filter size={15} className="text-zano-charcoal" data-id="element-294" data-mp="13eryuvp5lpuf" />
                  </div>
                  <span className="text-gray-700 text-sm" data-id="element-295" data-mp="13gm99g2stzk9">
                    <span className="font-semibold text-zano-charcoal" data-id="element-296" data-mp="zehlgxz17x5j">
                      Sort and filter submissions
                    </span>{' '}
                    — View all inbound pitches in one place. Sort by agency,
                    filter by follower count, views, exclusivity, and more.
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-297" data-mp="fpgul48lhdbj">
                  <div className="mt-0.5 bg-zano-lavender rounded-full p-1 shrink-0" data-id="element-298" data-mp="fnnp3s9pwz54">
                    <Users size={15} className="text-zano-charcoal" data-id="element-299" data-mp="1w25m2231v71c" />
                  </div>
                  <span className="text-gray-700 text-sm" data-id="element-300" data-mp="1r3kn05zjateh">
                    <span className="font-semibold text-zano-charcoal" data-id="element-301" data-mp="1zlmlpfafetjg">
                      Connect directly
                    </span>{' '}
                    — Click any submitted profile to view deep analytics, then
                    grab the talent manager's direct email to continue the
                    conversation.
                  </span>
                </li>
              </ul>
            </div>
          </Reveal>

          {/* Layered Visual */}
          <Reveal delay={0.1} data-id="element-302" data-mp="2icntmstixzf5">
            <div className="relative h-[500px] w-full" data-id="element-303" data-mp="2naz2b08323vs">
              {/* Glow */}
              <div className="absolute -inset-6 bg-gradient-to-tr from-sky-100/40 via-zano-lavender/30 to-zano-pink/10 rounded-[2.5rem] blur-2xl -z-10" data-id="element-304" data-mp="2ncs1xvka3nua" />

              {/* Base Layer: Submissions Table */}
              <div className="absolute top-8 right-0 w-[110%] bg-white rounded-xl border border-gray-200 shadow-sm overflow-hidden z-10 flex flex-col h-[400px]" data-id="element-305" data-mp="31aqdyub4n86m">
                <div className="p-4 border-b border-gray-100 bg-gray-50/50 flex justify-between items-center" data-id="element-306" data-mp="3631bxrmb4jwj">
                  <div data-id="element-307" data-mp="1hgyqeoer9so7">
                    <h4 className="text-base font-bold text-gray-900" data-id="element-308" data-mp="1de20sdqsswar">
                      Submissions: Summer Campaign
                    </h4>
                    <p className="text-xs text-gray-500" data-id="element-309" data-mp="18fqrq58buptl">
                      24 creators pitched by 8 agencies
                    </p>
                  </div>
                  <div className="flex gap-2" data-id="element-310" data-mp="213d7ebutxkwt">
                    <button className="flex items-center gap-1 border border-gray-200 bg-white px-2.5 py-1.5 rounded text-xs font-medium text-gray-700" data-id="element-311" data-mp="2133fgiq853oh">
                      <Filter size={12} data-id="element-312" data-mp="1rdjw7byln7t3" /> Filter
                    </button>
                  </div>
                </div>
                <div className="flex-1 overflow-hidden p-4 bg-gray-50" data-id="element-313" data-mp="1mfi98fy1yocc">
                  <div className="bg-white border border-gray-200 rounded-lg overflow-x-auto" data-id="element-314" data-mp="2jtukx973c9xl">
                    <table className="w-full text-left text-xs whitespace-nowrap" data-id="element-315" data-mp="2f3ny9ew52zhz">
                      <thead className="text-gray-500 border-b border-gray-100 bg-white" data-id="element-316" data-mp="2f1kw5whppfww">
                        <tr data-id="element-317" data-mp="2mgn8wfzs88d9">
                          <th className="px-3 py-2 font-medium" data-id="element-318" data-mp="2rddo713rizxm">Creator</th>
                          <th className="px-3 py-2 font-medium" data-id="element-319" data-mp="2rfgk21rljna9">Agency</th>
                          <th className="px-3 py-2 font-medium" data-id="element-320" data-mp="2wbf2z9u5od3a">Quote</th>
                          <th className="px-3 py-2 font-medium" data-id="element-321" data-mp="31cumuyklkdk3">Notes</th>
                        </tr>
                      </thead>
                      <tbody className="divide-y divide-gray-50" data-id="element-322" data-mp="35d4x4nff9q4r">
                        {[{
                        name: 'Michelle Brown',
                        photo: 'https://images.unsplash.com/photo-1534528741775-53994a69daeb?auto=format&fit=crop&w=64&h=64',
                        agency: 'Clicks Talent',
                        quote: '$1,200',
                        notes: 'Perfect fit for summer vibe...'
                      }, {
                        name: 'Marcus Chen',
                        photo: 'https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?auto=format&fit=crop&w=64&h=64',
                        agency: 'Viral Nation',
                        quote: '$950',
                        notes: 'Highly engaged tech audience...'
                      }, {
                        name: 'Stephanie & Loreal',
                        photo: 'https://images.unsplash.com/photo-1517841905240-472988babdf9?auto=format&fit=crop&w=64&h=64',
                        agency: 'Boost Society',
                        quote: '$2,000',
                        notes: 'Duo package deal...'
                      }, {
                        name: 'Julius Doyle',
                        photo: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?auto=format&fit=crop&w=64&h=64',
                        agency: 'Connect Management',
                        quote: '$800',
                        notes: 'Available next week...'
                      }, {
                        name: 'Elena Rodriguez',
                        photo: 'https://images.unsplash.com/photo-1524504388940-b1c1722653e1?auto=format&fit=crop&w=64&h=64',
                        agency: 'UTA',
                        quote: '$1,500',
                        notes: 'Great for beauty...'
                      }].map((s, i) => <tr key={i} className="hover:bg-gray-50 cursor-pointer" data-id="element-323" data-mp="3lmgpwkcyey6m" data-mpi={i}>
                            <td className="px-3 py-2 font-medium text-gray-900 flex items-center gap-2" data-id="element-324" data-mp="1juu3kw40brgh">
                              <img src={s.photo} alt={s.name} className="w-6 h-6 rounded-full object-cover" data-id="element-325" data-mp="2sezlsbsvk6lf" />
                              {s.name}
                            </td>
                            <td className="px-3 py-2 text-gray-600" data-id="element-326" data-mp="2em9zs7dcj1ob">
                              {s.agency}
                            </td>
                            <td className="px-3 py-2 text-green-600 font-medium" data-id="element-327" data-mp="29m5i4e0pc0wi">
                              {s.quote}
                            </td>
                            <td className="px-3 py-2 text-gray-400 truncate max-w-[120px]" data-id="element-328" data-mp="1zr3rteuowssc">
                              {s.notes}
                            </td>
                          </tr>)}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>

              {/* Floating Layer 1: Create Casting Call Form */}
              <motion.div initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.5,
              delay: 0.3
            }} className="absolute -top-4 -left-4 sm:-left-8 w-72 bg-white rounded-xl border border-gray-200 shadow-[0_20px_40px_-15px_rgba(0,0,0,0.1)] p-5 z-20" data-id="element-329" data-mp="1btnw2idinfgg">
                <div className="flex items-center gap-2 mb-4" data-id="element-330" data-mp="11vi1ymxybdm5">
                  <div className="w-8 h-8 rounded-lg bg-zano-blush flex items-center justify-center" data-id="element-331" data-mp="16ve4siuwwz04">
                    <FileText size={16} className="text-zano-pink" data-id="element-332" data-mp="2dbyfgapy3k6d" />
                  </div>
                  <h4 className="text-sm font-bold text-gray-900" data-id="element-333" data-mp="2iaj7vnyygzk9">
                    New Casting Call
                  </h4>
                </div>
                <div className="space-y-3" data-id="element-334" data-mp="3vjs7nw9zijwa">
                  <div data-id="element-335" data-mp="4e0j31buvfbl">
                    <label className="text-[10px] font-semibold text-gray-500 uppercase tracking-wider" data-id="element-336" data-mp="4d8nvrm67jlu">
                      Campaign Name
                    </label>
                    <div className="mt-1 text-xs text-gray-800 border border-gray-200 rounded-md px-3 py-2 bg-gray-50" data-id="element-337" data-mp="e3tua1835sfb">
                      Summer Skincare Launch
                    </div>
                  </div>
                  <div className="grid grid-cols-2 gap-3" data-id="element-338" data-mp="3hkabuwy9u6df">
                    <div data-id="element-339" data-mp="3hksfwfr6dovw">
                      <label className="text-[10px] font-semibold text-gray-500 uppercase tracking-wider" data-id="element-340" data-mp="3mjn09m4sjli4">
                        Budget
                      </label>
                      <div className="mt-1 text-xs text-gray-800 border border-gray-200 rounded-md px-3 py-2 bg-gray-50" data-id="element-341" data-mp="3qmjphvou6fv1">
                        $5k - $10k
                      </div>
                    </div>
                    <div data-id="element-342" data-mp="15x2mr8cflvch">
                      <label className="text-[10px] font-semibold text-gray-500 uppercase tracking-wider" data-id="element-343" data-mp="2qcsbgwzyk7qg">
                        Platforms
                      </label>
                      <div className="mt-1 flex gap-1.5 border border-gray-200 rounded-md px-3 py-2 bg-gray-50" data-id="element-344" data-mp="2mdjhps4x49uw">
                        <TTIco data-id="element-345" data-mp="2cln93n57h1cf" /> <IGIco data-id="element-346" data-mp="2clvlzf1bw6nm" />
                      </div>
                    </div>
                  </div>
                  <div data-id="element-347" data-mp="27n27bjab29lv">
                    <label className="text-[10px] font-semibold text-gray-500 uppercase tracking-wider" data-id="element-348" data-mp="27nlo2wo7yryb">
                      Deliverables
                    </label>
                    <div className="mt-1 text-xs text-gray-600 border border-gray-200 rounded-md px-3 py-2 bg-gray-50 h-12" data-id="element-349" data-mp="1ylkt66ggkhzt">
                      1x TikTok Video, 1x IG Story with link...
                    </div>
                  </div>
                  <button className="w-full bg-zano-pink text-white rounded-md py-2.5 text-xs font-bold mt-2 shadow-sm hover:bg-zano-pinkDark transition-colors" data-id="element-350" data-mp="3sykhqp2tgmj8">
                    Post to 400+ Agencies
                  </button>
                </div>
              </motion.div>

              {/* Floating Layer 2: Profile → direct manager email CTA */}
              <motion.div initial={{
              opacity: 0,
              scale: 0.92
            }} whileInView={{
              opacity: 1,
              scale: 1
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.45,
              delay: 0.5
            }} className="absolute bottom-4 -right-4 sm:-right-8 w-64 bg-white rounded-xl border border-gray-200 shadow-[0_20px_45px_-15px_rgba(0,0,0,0.18)] p-4 z-30" data-id="element-351" data-mp="1zbh9q13mk4z">
                <div className="flex items-center gap-2.5 mb-3" data-id="element-352" data-mp="35fimw232qrge">
                  <img src="https://images.unsplash.com/photo-1534528741775-53994a69daeb?auto=format&fit=crop&w=64&h=64" alt="Michelle Brown" className="w-9 h-9 rounded-full object-cover" data-id="element-353" data-mp="35iemduuklo6y" />
                  <div data-id="element-354" data-mp="2xw0zgdmplhek">
                    <p className="text-xs font-bold text-gray-900 leading-tight" data-id="element-355" data-mp="2xyna4m4wcd10">
                      Michelle Brown
                    </p>
                    <span className="inline-flex items-center gap-1 text-[10px] font-semibold text-emerald-700" data-id="element-356" data-mp="36wz5t2kme10b">
                      <span className="w-1.5 h-1.5 rounded-full bg-emerald-500" data-id="element-357" data-mp="2j8oasg1luvjy" />
                      Exclusive · Clicks Talent
                    </span>
                  </div>
                </div>
                <p className="text-[10px] font-semibold text-gray-500 uppercase tracking-wider mb-1" data-id="element-358" data-mp="2syhk1ae9yyl1">
                  Talent manager
                </p>
                <div className="flex items-center justify-between gap-2 bg-zano-blush/60 border border-zano-pink/20 rounded-md px-2.5 py-1.5 mb-2" data-id="element-359" data-mp="20h58kbfenliz">
                  <span className="flex items-center gap-1.5 text-[11px] font-medium text-zano-charcoal truncate" data-id="element-360" data-mp="1vhaksgqxfc25">
                    <Mail size={12} className="text-zano-pink shrink-0" data-id="element-361" data-mp="296lznv5bnl78" />
                    john@clickstalent.com
                  </span>
                  <button aria-label="Copy manager email" className="p-1 rounded bg-white border border-gray-200 text-gray-500 hover:text-zano-pink hover:border-zano-pink transition-colors shrink-0" data-id="element-362" data-mp="2j38kijxnec99">
                    <Copy size={11} data-id="element-363" data-mp="2rv0qahbq8x7i" />
                  </button>
                </div>
              </motion.div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>;
};